import { createReference } from '@quromedical/fhir-common';
import { DisplayList, DisplayView } from 'components/fhir';
import { FormCard, RowConfig } from 'design-system';
import React from 'react';
import { strings } from 'strings';

import { InitialCareTeamTemplate } from './CareTeamForm';

interface CardProps {
  data?: InitialCareTeamTemplate;
  canEdit: boolean;
  onEditPress: () => void;
  onCancel?: () => void;
}

const getCareTeamRows = (careTeam: Partial<InitialCareTeamTemplate> = {}): RowConfig[] => {
  const commonRows: RowConfig[] = [
    {
      icon: 'people-outline',
      fields: [
        {
          type: 'text',
          label: strings.LabelName,
          display: careTeam.name,
        },
        {
          type: 'custom',
          label: strings.LabelManagingOrganization,
          Display: () => (
            <DisplayView
              reference={createReference('Organization', careTeam.managingOrganization as string)}
            />
          ),
        },
        {
          type: 'custom',
          label:
            (careTeam.teamMembers?.length as number) > 1
              ? strings.GeneralPractitioners
              : strings.TitlePractitioner,
          Display: () => (
            <DisplayList
              variant="body-strong"
              references={careTeam.teamMembers?.map(k =>
                createReference('Practitioner', k.member as string)
              )}
            />
          ),
        },
        {
          type: 'text',
          label: strings.LocationStatus,
          display: careTeam.status,
        },
      ],
    },
  ];

  return commonRows;
};

export const GeneralCareTeamCard: React.FC<CardProps> = ({ data, canEdit, onEditPress }) => {
  const rows = getCareTeamRows(data);

  return (
    <FormCard
      isButtonVisible={canEdit}
      onButtonPress={onEditPress}
      buttonText={strings.ButtonTextEdit}
      buttonIcon="edit"
      showIcons
      title={strings.FormLabelPersonDetails}
      rows={rows}
    />
  );
};
